module.exports = __webpack_public_path__ + "static/img/first-win-speed.c38e385.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/first-win-speed.png
// module id = 2T/P
// module chunks = 0